module.exports = __webpack_public_path__ + "img/zhongqi.fafb690a.png";